import PageContent from '../../components/PageContent';
import {TeamItem} from "./components/TeamItem";
import {useQuery} from "react-query";
import {getSecurityTeams} from "../../api/Team";
import {useEffect, useMemo} from "react";
import {Spin} from "antd";
import {getPersonalInfo} from "../../api/User";
import {useSelector} from "react-redux";
import {currentUser} from "../../features/user/userSlice";

export const SecurityTeam = () => {
    const {isLoading, data} = useQuery('teams', getSecurityTeams)
    const user = useSelector(currentUser) ?? {};

    const {data: userInfo} = useQuery('userinfo', () => getPersonalInfo(), {
        enabled: !!user.token && user.user.type === 0
    })

    const userMemberStatus = useMemo(() => {
        const status = userInfo?.data.member_status
        return status ? +status : 0
    }, [userInfo])

    const teams = useMemo(() => {
        return data?.data || []
    }, [data])

    return (
        <PageContent>
            <Spin spinning={isLoading}>
                {
                    teams.map(team => (
                        <TeamItem team={team} userMemberStatus={userMemberStatus} key={team.title} />
                    ))
                }
            </Spin>
        </PageContent>
    );
};
